import { Centrifuge } from 'centrifuge'
import { storageService } from '@/services'
import { BE_LIMIT_TYPE } from '@/components/Limits/constants'
import { EVENTS } from '@/components/Bonuses/constants'
import { isNullOrUndefined } from '@/util/validators/baseComponentsValidators'

const WS_EVENTS = {
  LIMITS: 'user',
  BALANCE: 'balance',
}

export default ({ $config, store }, inject) => {
  let centrifuge = null
  inject('WS', {
    init: () => {
      if (centrifuge) {
        console.warn('Centrifuge: The module has already been initialized')
        return
      }
      /** Connect */
      centrifuge = new Centrifuge(`${$config.API_WS_URL}/connection/websocket`, {
        getToken: async() => storageService.getToken() || store.getters['user/get_guestUserToken'],
      })
      centrifuge.connect()

      /** Prepare */
      const userId = store.getters['user/userId']

      /** Limits Sub */
      centrifuge
        .newSubscription(`${WS_EVENTS.LIMITS}#${userId}`)
        .on('publication', async ({ data }) => {
          const isNewPromotion = data?.event && data?.event === 'new_bonus'
          if (isNewPromotion) store.dispatch('promotions/add_newPromotions')

          const gamePause = data?.limits?.pause
          gamePause && store.commit('limits/set_limitsGamePause', data?.limits)

          if (data.event === EVENTS.FS_BONUS_ACTIVATED) $nuxt.$emit(EVENTS.FS_BONUS_ACTIVATED)

          const gameExceededLimits = data?.limits?.exceeded_limits?.find(el => el.type === BE_LIMIT_TYPE.GAME_SESSION)
          if (gameExceededLimits) {
            store.commit('limits/set_gameExceededLimits', gameExceededLimits)
          }
          else {
            if (store.getters['game/get_isShowLimitsExceededModal']) {
              await store.dispatch('game/fetch_game')
            }
          }
        })
        .subscribe()

      /** Balance Sub */
      centrifuge
        .newSubscription(`${WS_EVENTS.BALANCE}#${userId}`)
        .on('publication', ({ data }) => {
          const balance = data?.balance
          balance && store.dispatch('user/act_userBalance', balance)
        })
        .subscribe()

      /** Jackpots Sub */
      centrifuge
        .newSubscription('public:sync-data')
        .on('publication', ({ data }) => {
          console.log('public event')
        })
        .subscribe()
    },
    disconnect: () => {
      if (isNullOrUndefined(centrifuge)) return
      centrifuge.disconnect()
      centrifuge = null
    },
  })
}
